module.exports = __webpack_public_path__ + "media/960bn3.1419889f.mp4";